import { appRoutes } from '#services';
export const verifyEmailRoutePredicate = ({ currentUser, defaultRoute, location, }) => {
    const locationState = location?.state;
    if (!currentUser) {
        return { isSuccess: false, navigateTo: appRoutes.login() };
    }
    if (!currentUser?.emailVerified) {
        return { isSuccess: true };
    }
    if (currentUser?.pendingInvitation) {
        return {
            isSuccess: false,
            navigateTo: appRoutes.invite(),
            locationState: { pendingInvite: undefined }, // The invite will be read from the currentUser
        };
    }
    return {
        isSuccess: false,
        navigateTo: locationState?.navigatedFrom || defaultRoute,
    };
};
